import { NgModule } from '@angular/core'
import { AnalyticsModule } from '../../shared/analytics/analytics.module'
import { FloPipeModule } from '../../shared/pipes/flo-pipe.module'
import { ResponsiveImageModule } from '../../shared/responsive-image/responsive-image.module'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { LandingPageLegacyComponent } from './components/landing-page-legacy/landing-page-legacy.component'
import { BatmanHeroComponent } from '../shared/hero-legacy/batman-hero.component'
import { BatmanFeatureComponent } from '../shared/batman-feature/batman-feature.component'
import { CalendarTileComponent } from '../shared/calendar-tile/calendar-tile.component'
import { OfferedDevicesComponent } from '../shared/offered-devices/offered-devices.component'
import { BatmanDataService } from './batman-data.service'
import { LazyLoadImageModule } from '../../shared/lazy-image/lazyload-image.module'
import { FunnelSharedModule } from '../shared/funnel-shared.module'
import { SharedModule } from '../../shared/shared.module'
import { OldSvgModule } from 'src/app/libs/_deprecated/svg/old-svg.module'
import { LandingPageComponent } from './components/landing-page.component'
import { LandingHeroComponent } from './components/landing-hero/landing-hero.component'
import { PlansPromoModule } from '../plans/plans-promo/plans-promo.module'
import { LogosDisplayComponent } from './components/logos-display/logos-display.component'
import { EventCardScrollModule } from '../thank-you/event-card-scroll/event-card-scroll.module'
import { FaqModule } from '../faq/faq.module'
import { ElementIsVisibleModule } from 'src/app/libs/element-is-visible/element-is-visible.module'

@NgModule({
  imports: [
    CommonModule,
    AnalyticsModule,
    FloPipeModule,
    ResponsiveImageModule,
    RouterModule,
    OldSvgModule,
    LazyLoadImageModule,
    FunnelSharedModule,
    SharedModule,
    PlansPromoModule,
    EventCardScrollModule,
    FaqModule,
    ElementIsVisibleModule
  ],
  declarations: [
    LandingPageLegacyComponent,
    LandingPageComponent,
    BatmanHeroComponent,
    LandingHeroComponent,
    BatmanFeatureComponent,
    CalendarTileComponent,
    OfferedDevicesComponent,
    LogosDisplayComponent
  ],
  exports: [
    LandingPageLegacyComponent,
    LandingPageComponent,
    BatmanHeroComponent,
    LandingHeroComponent,
    BatmanFeatureComponent,
    CalendarTileComponent,
    OfferedDevicesComponent,
    LogosDisplayComponent
  ],
  providers: [BatmanDataService]
})
export class LandingPageModule {}
